import baseApi from '../../lib/baseApi';

// Fetch Social Links ---------------------------------------------------------------
export const fetchSocialLinksApi = async (contentType: string, objectId: number) => {
  const response = await baseApi.get(`/accounts/social-links/list/`, {
    params: {
      content_type: contentType,
      object_id: objectId,
    },
  });
  return response.data;
};

// Add a Social Link ---------------------------------------------------------------
export const addSocialLinkApi = async (linkData: any) => {
  const response = await baseApi.post(`/accounts/social-links/add/`, linkData);
  return response.data;
};


// Delete a Social Link ---------------------------------------------------------------
export const deleteSocialLinkApi = async (linkId: number) => {
  const response = await baseApi.delete(`/accounts/social-links/delete/`, {
    params: { id: linkId },
  });
  return response.data;
};

// Fetch Social Media Types ---------------------------------------------------------------
export const fetchSocialMediaTypesApi = async () => {
  const response = await baseApi.get(`/accounts/social-links/social-media-types/`);
  return response.data;
};
